import { Link } from 'react-router-dom';
import { allContent } from '@/mocks/siteData';

export default function TrendingRanking() {
  const trending = [...allContent].sort((a, b) => b.views - a.views).slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
              <i className="ri-trophy-line"></i>
              热门排行
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              在线观看排行榜
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {trending.map((item, index) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl font-bold text-lg ${
                index < 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {index + 1}
              </div>
              <div className="w-24 h-16 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={item.image}
                  alt={`在线观看${item.title}`}
                  title={`在线观看${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-1.5">
                  <span className="text-xs px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full">{item.categoryName}</span>
                  <span className="text-xs text-foreground-400">{item.year}</span>
                </div>
              </div>
              <div className="hidden sm:flex items-center gap-3 text-xs text-foreground-400 flex-shrink-0">
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-secondary-400"></i>
                  {item.rating}
                </span>
                <span>{item.views.toLocaleString()}次观看</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}